/**
 * @file JobTeaserCustomBadgeSlot.tsx
 *
 * @fileoverview This component renders additional things to the job teaser next to the featured badge
 * and can be used to add custom badge to this section.
 */
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { Job } from '~/jobiqo/types/types';

interface JobTeaserCustomBadgeSlotProps {
  /**
   * The job entity.
   */
  job: Slottable<Job>;
}

export default function JobTeaserCustomBadgeSlot({
  job,
}: JobTeaserCustomBadgeSlotProps) {
  return null;
}

export { JobTeaserCustomBadgeSlot };
